
import { ServicePackage, PortfolioItem } from './types';

export const SITE_NAME = "PHOTO ELYK";
export const BRAND_COLOR = "#FF4D00"; 
export const INSTAGRAM_URL = "https://instagram.com/photoelyk";

export const HERO_IMAGE_URL = "https://images.unsplash.com/photo-1554048612-b6a482bc67e5?q=80&w=2070&auto=format&fit=crop";

export const REEL_IMAGES = [
  "https://res.cloudinary.com/dxvma4lwc/image/upload/v1764660811/IMG_0684_fezir4.jpg",
  "https://res.cloudinary.com/dxvma4lwc/image/upload/v1764660137/20180101-01002_p4oyir.jpg",
  "https://res.cloudinary.com/dxvma4lwc/image/upload/v1764660037/20180101-00150_gl3reg.jpg",
  "https://res.cloudinary.com/dxvma4lwc/image/upload/v1766178375/20180120_071302000_iOS_u335eh_f84ec7.jpg",
  "https://res.cloudinary.com/dxvma4lwc/image/upload/v1764626584/20180122_025720000_iOS_iykhui.jpg",
  "https://res.cloudinary.com/dxvma4lwc/image/upload/v1764569414/TheDoubleDos_1_iozklf.jpg"
];

export const PROCESS_STEPS = [
  {
    id: '01',
    title: 'THE VISION',
    desc: 'We start with a consultation to map out your aesthetic, locations, and styling.',
    icon: 'M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z'
  },
  {
    id: '02',
    title: 'THE SESSION',
    desc: 'A dynamic, high-energy shoot focused on capturing authentic, sharp frames.',
    icon: 'M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z M15 13a3 3 0 11-6 0 3 3 0 016 0z'
  },
  {
    id: '03',
    title: 'THE DELIVERY',
    desc: 'Receive your hand-edited, high-res gallery within 48-72 hours of shooting.',
    icon: 'M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z'
  }
];

export const TESTIMONIALS = [
  {
    name: 'CHRIS V.',
    role: 'Creator / Musician',
    text: 'Elyk has an insane eye for detail. The lighting was exactly what my brand needed to stand out.',
    rating: 5
  },
  {
    name: 'OLIVIA R.',
    role: 'Lifestyle Model',
    text: 'Best session I’ve ever had. He makes you feel comfortable and the results speak for themselves.',
    rating: 5
  },
  {
    name: 'SHAD T.',
    role: 'Entrepreneur',
    text: 'Fast delivery, elite quality. If you are in Boston and need professional work, this is it.',
    rating: 5
  }
];

export const PORTFOLIO_ITEMS: PortfolioItem[] = [
  { 
    id: 1, 
    category: 'CREATORS', 
    title: 'KurlyChris', 
    coverImage: 'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764626543/20180121_051829000_iOS1_vody9v.jpg',
    sessionImages: [
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764626543/20180121_051829000_iOS1_vody9v.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764626546/20180121_052452000_iOS_umycfy.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764626541/20180121_055736000_iOS_pnytqd.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764626549/20180122_024904000_iOS1_xhkajs.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764626538/20180121_072836000_iOS1_kbrxjn.jpg',
    ]
  },
  { 
    id: 2, 
    category: 'EVENTS', 
    title: 'Masquerade Party', 
    coverImage: 'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764660104/20180101-00430_qysbcx.jpg',
    sessionImages: [
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764660104/20180101-00430_qysbcx.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764660152/20180101-00096_wbjbrp.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764660042/20180101-00201_rztu8d.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764660044/20180101-00220_fd3mta.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764660121/20180101-00496_jqfpkr.jpg'
    ]
  },
  { 
    id: 3, 
    category: 'CREATORS', 
    title: 'SunKissed_Liv', 
    coverImage: 'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764578260/20180121_033305000_iOS_hjvzry.jpg',
    sessionImages: [
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764578260/20180121_033305000_iOS_hjvzry.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764578446/20180121_033332000_iOS_cet9se.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764578444/20180121_033503000_iOS_pvifxu.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764578254/20180121_033247000_iOS_nq1iam.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764578451/20180121_033344000_iOS_lvy3qb.jpg'
    ]
  },
  { 
    id: 4, 
    category: 'CREATORS', 
    title: 'AverageShad', 
    coverImage: 'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764622485/20180121_041027000_iOS_trdd7d.jpg',
    sessionImages: [
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764622485/20180121_041027000_iOS_trdd7d.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764622483/20180121_040934000_iOS_yyt06t.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764622596/20180121_041614000_iOS_1_wzmkjn.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764622486/20180121_041120000_iOS_amexqr.jpg',
    ]
  },
  { 
    id: 5, 
    category: 'CREATORS', 
    title: 'VibeyVee', 
    coverImage: 'https://res.cloudinary.com/dxvma4lwc/image/upload/v1766178029/20180121_023234000_iOS_ddwqn1_i8kese_c3xwds_8c50f3.jpg',
    sessionImages: [
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1766178029/20180121_023234000_iOS_ddwqn1_i8kese_c3xwds_8c50f3.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764623258/20180121_051054000_iOS_ja1ugy.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764623331/20180121_041342000_iOS_a5x8ay.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764623273/20180121_050959000_iOS_wtc4gw.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764623331/20180121_041342000_iOS_a5x8ay.jpg'
    ]
  },
  { 
    id: 6, 
    category: 'CREATORS', 
    title: 'SaltyGummiBear', 
    coverImage: 'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764659085/20180121_050424000_iOS_gsqg98_cw9upo.jpg',
    sessionImages: [
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764622969/20180121_050424000_iOS_gsqg98.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764622967/20180121_050419000_iOS_vxce8b.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764622966/20180121_050416000_iOS_zffuky.jpg',
      'https://res.cloudinary.com/dxvma4lwc/image/upload/v1764622964/20180121_050344000_iOS1_oo2yhm.jpg',
    ]
  }
];

export const SERVICE_PACKAGES: ServicePackage[] = [
  { 
    id: '01', 
    number: '01', 
    title: 'PORTRAITS', 
    price: '$150', 
    features: [
      '45 MIN SESSION', 
      '10 EDITED HIGH-RES IMAGES', 
      '1 LOCATION', 
      '1 OUTFIT LOOK', 
      'PERSONAL ONLINE GALLERY', 
      'STUDENT DISCOUNT: $100'
    ],
    highlightedFeature: 'STUDENT DISCOUNT: $100'
  },
  { 
    id: '02', 
    number: '02', 
    title: 'CREATORS', 
    price: '$350', 
    isFeatured: true, 
    features: [
      '2 HOUR SESSION', 
      '40+ CURATED IMAGES', 
      'MULTIPLE URBAN LOCATIONS', 
      'UNLIMITED LOOKS', 
      '4K BTS VIDEO CONTENT', 
      '48HR EXPEDITED DELIVERY'
    ] 
  },
  { 
    id: '03', 
    number: '03', 
    title: 'PRODUCTS', 
    price: '$225', 
    features: [
      'PER COLLECTION', 
      'LIFESTYLE BRAND SHOTS', 
      'E-COMMERCE STUDIO SHOTS', 
      'FULL COMMERCIAL LICENSE', 
      'PROFESSIONAL RETOUCHING'
    ] 
  },
  { 
    id: '04', 
    number: '04', 
    title: 'EVENTS', 
    price: '$450', 
    features: [
      '4 HOUR MINIMUM', 
      'COMPREHENSIVE COVERAGE', 
      'CANDID & ATMOSPHERE SHOTS', 
      'NEXT-DAY SOCIAL HIGHLIGHTS', 
      'OPTIONAL FILM PHOTOGRAPHY'
    ] 
  }
];
